const actions = {
  VOLUNTEER_LISTING_ADD_BEGIN: 'VOLUNTEER_LISTING_ADD_BEGIN',
  VOLUNTEER_LISTING_ADD_SUCCESS: 'VOLUNTEER_LISTING_ADD_SUCCESS',
  VOLUNTEER_LISTING_ADD_ERR: 'VOLUNTEER_LISTING_ADD_ERR',
  
  VOLUNTEER_LISTINGS_READ_BEGIN: 'VOLUNTEER_LISTINGS_READ_BEGIN',
  VOLUNTEER_LISTINGS_READ_SUCCESS: 'VOLUNTEER_LISTINGS_READ_SUCCESS',
  VOLUNTEER_LISTINGS_READ_ERR: 'VOLUNTEER_LISTINGS_READ_ERR',

  VOLUNTEER_LISTING_UPDATE_BEGIN: 'VOLUNTEER_LISTING_UPDATE_BEGIN',
  VOLUNTEER_LISTING_UPDATE_SUCCESS: 'VOLUNTEER_LISTING_UPDATE_SUCCESS',
  VOLUNTEER_LISTING_UPDATE_ERR: 'VOLUNTEER_LISTING_UPDATE_ERR',

  VOLUNTEER_LISTING_DELETE_BEGIN: 'VOLUNTEER_LISTING_DELETE_BEGIN',
  VOLUNTEER_LISTING_DELETE_SUCCESS: 'VOLUNTEER_LISTING_DELETE_SUCCESS',
  VOLUNTEER_LISTING_DELETE_ERR: 'VOLUNTEER_LISTING_DELETE_ERR',

  VOLUNTEER_LISTING_READ_BEGIN: 'VOLUNTEER_LISTING_READ_BEGIN',
  VOLUNTEER_LISTING_READ_SUCCESS: 'VOLUNTEER_LISTING_READ_SUCCESS',
  VOLUNTEER_LISTING_READ_ERR: 'VOLUNTEER_LISTING_READ_ERR',

  VOLUNTEER_LISTING_UPLOAD_BEGIN: 'VOLUNTEER_LISTING_UPLOAD_BEGIN',
  VOLUNTEER_LISTING_UPLOAD_SUCCESS: 'VOLUNTEER_LISTING_UPLOAD_SUCCESS',
  VOLUNTEER_LISTING_UPLOAD_ERR: 'VOLUNTEER_LISTING_UPLOAD_ERR',
  
  CATEGORIES_READ_BEGIN: 'CATEGORIES_READ_BEGIN',
  CATEGORIES_READ_SUCCESS: 'CATEGORIES_READ_SUCCESS',
  CATEGORIES_READ_ERR: 'CATEGORIES_READ_ERR',

  ORG_VOLUNTEER_LISTINGS_READ_BEGIN: 'ORG_VOLUNTEER_LISTINGS_READ_BEGIN',
  ORG_VOLUNTEER_LISTINGS_READ_SUCCESS: 'ORG_VOLUNTEER_LISTINGS_READ_SUCCESS',
  ORG_VOLUNTEER_LISTINGS_READ_ERR: 'ORG_VOLUNTEER_LISTINGS_READ_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.VOLUNTEER_LISTINGS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.VOLUNTEER_LISTINGS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.VOLUNTEER_LISTINGS_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.VOLUNTEER_LISTING_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.VOLUNTEER_LISTING_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.VOLUNTEER_LISTING_ADD_ERR,
      err,
    };
  },

  axiosUpdateBegin: () => {
    return {
      type: actions.VOLUNTEER_LISTING_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.VOLUNTEER_LISTING_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.VOLUNTEER_LISTING_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.VOLUNTEER_LISTING_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.VOLUNTEER_LISTING_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.VOLUNTEER_LISTING_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.VOLUNTEER_LISTING_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.VOLUNTEER_LISTING_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.VOLUNTEER_LISTING_READ_ERR,
      err,
    };
  },

  axiosUploadBegin: () => {
    return {
      type: actions.VOLUNTEER_LISTING_UPLOAD_BEGIN,
    };
  },

  axiosUploadSuccess: data => {
    return {
      type: actions.VOLUNTEER_LISTING_UPLOAD_SUCCESS,
      data,
    };
  },

  axiosUploadErr: err => {
    return {
      type: actions.VOLUNTEER_LISTING_UPLOAD_ERR,
      err,
    };
  },

  axiosCategoriesReadBegin: () => {
    return {
      type: actions.CATEGORIES_READ_BEGIN,
    };
  },

  axiosCategoriesReadSuccess: data => {
    return {
      type: actions.CATEGORIES_READ_SUCCESS,
      data,
    };
  },

  axiosCategoriesReadErr: err => {
    return {
      type: actions.CATEGORIES_READ_ERR,
      err,
    };
  },

  axiosOrgVolunteerListingsReadBegin: () => {
    return {
      type: actions.ORG_VOLUNTEER_LISTINGS_READ_BEGIN,
    };
  },

  axiosOrgVolunteerListingsReadSuccess: data => {
    return {
      type: actions.ORG_VOLUNTEER_LISTINGS_READ_SUCCESS,
      data,
    };
  },

  axiosOrgVolunteerListingsReadErr: err => {
    return {
      type: actions.ORG_VOLUNTEER_LISTINGS_READ_ERR,
      err,
    };
  },

};

export default actions;
